import React from 'react';

export interface ClipIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ClipIcon: React.FC<ClipIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m21.774 11.166-9.19 9.19a6.003 6.003 0 1 1-8.49-8.49l9.19-9.19a4.002 4.002 0 0 1 5.66 5.66l-9.2 9.19a2.001 2.001 0 1 1-2.83-2.83l8.49-8.48"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.333.116h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default ClipIcon;
